import React from 'react'
import { Provider } from './Context'
import { AddToBoardButton } from './AddToBoardButton'
import { ShowIf } from '@ztechapps/webui.util'
import { useUser } from '@ztechapps/common.hook'

export const AddToBoard = ({ entity, triggerComponent, itemInfoComponent, addItemContent, addBoardContent }) => {
  const { loggedIn } = useUser()

  return (
    <ShowIf condition={loggedIn}>
      <Provider entity={entity}>
        <AddToBoardButton
          triggerComponent={triggerComponent}
          itemInfoComponent={itemInfoComponent}
          addItemContent={addItemContent}
          addBoardContent={addBoardContent}
        />
      </Provider>
    </ShowIf>
  )
}
